import { appInjector } from '../app-injector/AppInjector';
import { RoleType } from '../constants-types/Enums';
import { Person } from '../core-data-model/Person.model';
import { Util } from '../core-utilities/Util';

export class AssessmentAdministrator {
    firstName: string;
    lastName: string;
    phone: string;
    company: string;
    email: string;
    surveyUserId: string;
    // following is temporary to workaround API issue
    userId: string;
    userGuid: string;
    companyId: string;
    roleType: RoleType;
    hasCognitiveAccessUserLevel: boolean;
    apiUserId: string;
    isNetworkUser: boolean;
    lastLogin: Date;
    hasAcknowledgedCogBestPractices: boolean;
    createdTime: Date;
    roleName: string;
    apiCompanyId: string;

    constructor(obj?: any) {
        Object.assign(this, obj);
        // We should not be doing this. If we need to rely on Util we should
        // wrap this class in a factory to do proper DI. This means we have to have
        // a bunch of cruft in each of our Angular apps to get this working. IT's a total
        // gotcha and very confusing. Either make Util totally static and outside of DI or
        // use a factory for this class.
        const util: Util = appInjector().get(Util);
        if (obj) {
            this.lastLogin = util.newDate(obj.lastLogin);
            this.createdTime = util.newDate(obj.createdTime);
        }
    }

    fullName(lastNameFirst?: boolean): string {
        return Person.fullName(this, lastNameFirst);
    }

    isSuperAdmin(): boolean {
        return this.roleType === RoleType.SuperAdmin;
    }

    isAcccountOwner(): boolean {
        return this.roleType === RoleType.AccountOwner;
    }

    isPowerUser(): boolean {
        return this.roleType === RoleType.PowerUser;
    }

    isReadOnly(): boolean {
        return this.roleType === RoleType.ReadOnly;
    }

    hasPermissionLevelOrGreater(roleType: RoleType) {
        return this.roleType >= roleType;
    }

    inSavableState(realAdmin: AssessmentAdministrator): boolean {
        return (
            realAdmin.firstName !== this.firstName ||
            realAdmin.lastName !== this.lastName ||
            realAdmin.email !== this.email ||
            realAdmin.company !== this.company ||
            realAdmin.phone !== this.phone
        );
    }
}
